<template>
    <div class="button-wrapper flex">
        <button @click="$emit('click')" :disabled="isLoading" class="text-sm md:text-md flex py-2 px-4 rounded-full text-white hover:opacity-70 transition" :class="[isGhost ? 'border border-' + color : 'bg-' + color, isLoading ? '!opacity-70' : '']">
            {{ isLoading ? "Loading..." : label }}
        </button>
    </div>
</template>

<script>

export default {
    name: "ButtonStatusComponent",
    props: {
        label: { type: String, default: "" }, // Sets the label of the button
        color: { type: String, default: "light-blue" },
        isGhost: { type: Boolean, default: false },
        isLoading: { type: Boolean, default: false }
    }
};
</script>
